var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg18Years(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 65",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8441086,41.7626991H6.0956726V31.2284088c0-3.1136608,2.5241213-5.6377811,5.6377821-5.6377811h28.4728699   c3.1136589,0,5.6377831,2.5241203,5.6377831,5.6377811V41.7626991z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,41.7626648c0,2.9135056,2.971664,5.275341,6.6373758,5.275341h32.7252502   C46.0283356,47.0380058,49,44.6761703,49,41.7626648H3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.0956726,34.7791443c0,0,5.9178658,2.2915421,11.0923576-0.8389473   c1.2155018-0.7353592,2.7781448-0.6153908,3.8393688,0.3290672c1.7165012,1.5276375,4.7601128,3.3815842,9.3977661,3.3407593   c1.044548-0.0091972,2.016798-0.5527496,2.6061573-1.4152031c1.8197479-2.6629791,6.5717583-8.1169109,12.8127861-3.8922157"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5890236,18.7524586h-1.2382679c-1.2485485,0-2.2606869,1.0121403-2.2606869,2.2606869v4.5774841h5.7596436   v-4.5774841C28.8497124,19.7645988,27.8375721,18.7524586,26.5890236,18.7524586z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.6957932,4.9619942c0,0-1.7783985,3.2211428-2.3545151,5.8100624   c-0.398859,1.7923717,0.5460701,3.6725245,2.3034458,4.2047997l0.0510693,0.0151167c0,0,0.0854111,0.0068789,0.2294846,0.0028658   c2.2191753-0.0618105,3.4918461-2.5618477,2.3180466-4.4461889C27.4172649,9.2225504,26.2409744,7.0922723,25.6957932,4.9619942z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 25.9698906,
    y1: 12.9325943,
    x2: 25.9698906,
    y2: 18.7524586
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18Years);
export default __webpack_public_path__ + "static/media/18years.3ac1b9d08d082265798c141adc771f19.svg";
export { ForwardRef as ReactComponent };